export default {"src":"/newStatic/_next/static/media/pattern-6.6a4bd88d.svg","height":170,"width":1280};